import React, { useState } from "react";
import styles from '../../styles';
import { CardExpiryElement } from "@stripe/react-stripe-js";
import Typography from '@material-ui/core/Typography';
import FormHelperText from '@material-ui/core/FormHelperText';
import ErrorIcon from '@material-ui/icons/Error';

const CardExpiryField = (props) => {
  const [focus, setFocus] = useState(false);
  const [error, setError] = useState(null);
  const [empty, setEmpty] = useState(true);
  const classes = styles({ focus, empty, error });

  const cardStyle = {
    placeholder: '',
    style: {
      base: {
        color: 'rgba(0, 0, 0, 0.87)',
        fontFamily: 'Roboto, Open Sans',
        fontSize: "18px",
        "::placeholder": {
            color: focus ? "#707070" : "#fcfcfb"
        },
        ":hover": {
          "::placeholder": {
            color: "#fff"
          },
        }
      },
      complete: {
        color: "black",
        iconColor: "black"
      },
      invalid: {
        color: "black",
        iconColor: "black"
      },

    }
  };

  return (
    <div className={classes.mainContainer}>
      <div className={classes.cardContainer}>
        <Typography className={classes.typo}>Date d'expiration</Typography>
         <CardExpiryElement
           onBlur={() => {
             if (empty) {
               setError("La date d'expiration de votre carte est incomplète.")
               setFocus(false)
               props.setDisabled(true)
             } else {
               setFocus(false)
               props.setDisabled(false)
             }
           }}
           onFocus={() => setFocus(true)}
           onChange={(event) => {
             if (event.empty) {
               setEmpty(true)
               setError("La date d'expiration de votre carte est incomplète.")
               props.setDisabled(true)
             } else if (event.error) {
               setError(event.error.message)
               props.setDisabled(true)
             } else {
               setError(null)
               setEmpty(false)
               props.setDisabled(false)
             }
           }}
           options={cardStyle}
         />
      </div>
      <FormHelperText error={error} classes={{ root: classes.rootError, error: classes.error }} htmlFor="filled-adornment-textfield">
        <span className={classes.helperText}>
          {error
            && <ErrorIcon className={classes.icon} />}
          {error}
        </span>
      </FormHelperText>
    </div>
  );
};

export default CardExpiryField;
